export { Pager } from './Pager';
export type { PagerProps } from './Pager.types';
